import { AccessRightDomain } from '../types/access-right.interface';
import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';

export const accessRightDefinition: EntityDefinition<AccessRightDomain> = {
  entityType: 'AccessRightDomain',
  i18nBase: 'entities.access',
  list: {
    columns: [
      {
        field: 'assetGroupName',
        headerKey: 'entities.access.columns.assetGroup',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'assetName',
        headerKey: 'entities.access.columns.asset',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      {
        field: 'roleName',
        headerKey: 'entities.access.columns.role',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
    ],
  },
  rowLinkHref: entity => `/assets/${entity.assetId}/configuration/access-rights`,
  fields: [],
  validationFields: ['assetId', 'roleId'],
  validationRules: [
    {
      type: BusinessRuleType.CREATE_VALIDATION,
      rule: (entity: AccessRightDomain, store) => {
        if (!store) return true;
        const entities = store.getData<AccessRightDomain>('AccessRightDomain')();
        return !entities.some(a => a.roleId === entity.roleId && a.assetId === entity.assetId);
      },
      errorMessageKey: 'entities.access.messages.duplicateError',
    },
    {
      type: BusinessRuleType.EDIT_VALIDATION,
      rule: (entity: AccessRightDomain, store) => {
        if (!store) return true;
        const entities = store.getData<AccessRightDomain>('AccessRightDomain')();
        return !entities.some(ard => ard.roleId === entity.roleId && ard.assetId === entity.assetId);
      },
      errorMessageKey: 'entities.access.messages.duplicateError',
    },
  ],
  actionButtons: {
    parent: {
      edit: true,
    },
  },
  formOptions: {
    showDeleteButton: true,
  },
  messages: {
    dialogTitles: {
      create: () => 'entities.access.messages.createTitleWithName',
      edit: () => 'entities.access.messages.editTitleWithName',
      delete: () => 'entities.access.messages.deleteTitleWithName',
    },
    buttons: {
      add: () => ``,
      create: () => ``,
      edit: () => ``,
      delete: () => 'entities.access.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.access.messages.deleteConfirm',
  },
  // Identify the access by the user it grants — `name` is the projected display name.
  deleteName: entity => entity.name,
  enableFiltering: true,
};
